import { Box } from "@mui/joy";
import DOMPurify from 'dompurify';

export function openSidebar() {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
  }
}

export function closeSidebar() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--SideNavigation-slideIn');
    document.body.style.removeProperty('overflow');
  }
}

export function toggleSidebar() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--SideNavigation-slideIn');
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
}


export const adjustTime = (dateString, hoursToSubtract = 5) => {
  if (!dateString) return null;
  
  const date = new Date(dateString);
  date.setHours(date.getHours() - hoursToSubtract);
  
  return date;
};

// Добавляет High-Yield бейджи к Clinical-секциям и окрашивает High-Yield Facts
const addHighYieldBadges = (html) => {
    if (!html) return html;
    const badge = `<span style="display:inline-flex;align-items:center;margin-left:8px;padding:2px 10px;font-size:0.7rem;font-weight:700;letter-spacing:0.5px;text-transform:uppercase;color:#fff;background:#C96B2E;border-radius:20px;vertical-align:middle;line-height:1.4">HIGH YIELD</span>`;
    return html
        // Overview: увеличенный шрифт
        .replace(
            /(<h3)(>)([^<]*\bOverview\b[^<]*)(<\/h3>)/gi,
            `$1 style="font-size:1.6rem"$2$3$4`
        )
        // Clinical-секции: добавляем бейдж (содержимое без < чтобы не выйти за тег)
        .replace(
            /(<h[34][^>]*>)([^<]*\bClinical\b[^<]*)(<\/h[34]>)/gi,
            `$1$2${badge}$3`
        )
        // High-Yield Facts: красим заголовок в оранжевый
        .replace(
            /(<h[34])(>)([^<]*\bHigh[\s-]*Yield\b[^<]*)(<\/h[34]>)/gi,
            `$1 style="color:#C96B2E"$2$3$4`
        );
};

// Компонент для безопасного отображения HTML
export const SafeHTML = ({ html, ...props }) => {
    const processedHtml = addHighYieldBadges(html);
    return (
        <Box
            {...props}
            sx={{
                '& img': { maxWidth: '100%', height: 'auto !important' },
                '& table': { width: '100%', borderCollapse: 'collapse' },
                '& th, & td': { border: '1px solid', borderColor: 'neutral.300', p: 1 },
                '& ul, & ol': { pl: 2 },
                ...props.sx
            }}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(processedHtml) }}
        />
    );
};